import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { DateRange, endOfDay, isNil, Nillable } from '@web/utils';
import { PRIMENG_YY_MM_DD } from '@web/common';
import { DatePicker } from 'primeng/datepicker';

@Component({
  selector: 'app-table-filter-date-range',
  imports: [ReactiveFormsModule, DatePicker],
  templateUrl: './table-filter-date-range.component.html',
  styleUrls: ['./table-filter-date-range.component.scss'],
})
export class TableFilterDateRangeComponent implements OnInit, OnDestroy {
  private builder = inject(FormBuilder);

  @Input() public showTime = false;

  @Output() public readonly changes = new EventEmitter<Nillable<DateRange>>();

  public control!: FormControl<Date[]>;

  protected readonly DATE_RANGE_FORMAT = PRIMENG_YY_MM_DD;

  private readonly destroy$ = new Subject<void>();

  public ngOnInit(): void {
    this.configureControl();
    this.configureValueChangesSource();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private configureControl(): void {
    this.control = this.builder.nonNullable.control([]);
  }

  private configureValueChangesSource(): void {
    this.control.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: Nillable<Date[]>) => {
        this.changes.emit(this.prepareDateRange(value));
      });
  }

  private prepareDateRange(value: Nillable<Date[]>): Nillable<DateRange> {
    if (isNil(value)) {
      return;
    }

    const [from, to] = value;

    if (isNil(from) && isNil(to)) {
      return;
    }

    return {
      from: from,
      to: endOfDay(to ?? from),
    };
  }
}
